export default "__VITE_ASSET__SPsh8rT8__"